<template>
  <div class>
    <div class="total-data">
      <div class="total-data-item">
        <div class="p1">总销量</div>
        <div class="p2">{{ buyCount }}</div>
      </div>
      <div class="total-data-item">
        <div class="p1">学习次数</div>
        <div class="p2">{{ studyCount }}</div>
      </div>
      <div class="total-data-item">
        <div class="p1">学习人数</div>
        <div class="p2">{{ studyPersonCount }}</div>
      </div>
    </div>
    <div class="table-page-search-wrapper" style="border-top: 1px solid rgb(231, 236, 239);">
      <a-row :gutter="12" style="margin:16px 25px;">

        <a-col class="a-large-form">
          <a-form-item label style="margin-bottom:0px">
            <a-input placeholder="请输入学员名称" style="width:100%" v-model="queryParam.realname"></a-input>
          </a-form-item>
        </a-col>
        <a-col class="a-large-dbdate">
          <a-form-item label="" style="margin-bottom:0px">
            <a-range-picker style="width:100%" v-model="lastStudyTimeSt" @change="dateChange" />
          </a-form-item>
        </a-col>
        <a-button @click="searchQuery" type="primary" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >

      </a-table>
    </div>
  </div>
</template>

<script>
import { liveStudyFlow } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'CourseDataStatistics',
  mixins: [JeecgListMixin],
  data() {
    return {
      description: '课程评价',
      firstIsNotLoad: true,
      studyCount: 0,
      buyCount: 0,
      studyPersonCount: 0,
      lastStudyTimeSt: '',
      url: {
        list: '/magic/liveCourse/studyFlow',
        delete: '/course/connect/do'
        // deleteBatch: "/course/elinkxCourse/deleteBatch",
        // exportXlsUrl: "course/elinkxCourse/exportXls",
        // importExcelUrl: "course/elinkxCourse/importExcel",
      },
      queryParam: {
        courseId: '',
        userName: '',
        chapterName: '',
        startTime: '',
        endTime: ''
      },
      columns: [
        {
          title: '学员名称',
          align: 'center',
          dataIndex: 'realname',
          width: 100
        },
        // {
        //   title: '学习章节',
        //   align: 'center',
        //   dataIndex: 'chapterName',
        //   width: 150
        // },

        {
          title: '学习课时',
          align: 'center',
          dataIndex: 'chName',
          width: 100
        },
        {
          title: '学习次数',
          align: 'center',
          dataIndex: 'studyTimes',
          width: 100
        },
        {
          title: '最后学习时间',
          align: 'center',
          dataIndex: 'lastTime',
          width: 100
        }
      ],
      dataSource: []
    }
  },
  created() {
    this.queryParam.courseId = this.$route.query.courseId
    this.loadData()
    this.getData()
  },
  methods: {
    dateChange: function(data, data1) {
      this.queryParam.begTime = data1[0]
      this.queryParam.endTime = data1[1]
      // this.loadData()
    },
    getData: function() {
      liveStudyFlow({ courseId: this.queryParam.courseId }).then((res) => {
        if (res.success) {
          this.studyCount = res.result.cnt.totalCount || 0
          this.buyCount = res.result.cnt.buyCount || 0
          this.studyPersonCount = res.result.cnt.memberCount || 0
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
      })
    }
  }
}
</script>

<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .total-data{
      overflow: hidden;
    .total-data-item{
      float: left;
      width: 33.333%;
      margin:30px 0px;
      border-right: 1px solid #E7ECEF;
      &:last-child{
        border-right: none;
      }
      .p1{
        text-align:center;
        font-size: 14px;
        color: #333333;
      }
      .p2{
        text-align:center;
        color: #FA6400;
        font-size: 40px;
      }
    }
  }
</style>
